import { newsOrder } from '../constants/newsOrder';
import { AdminActionsEnum } from '../enums/AdminActionsEnum';
import { IAdminState } from '../interfaces/IAdminState';
import { AdminAction } from '../types/AdminAction';

const initial: IAdminState = {
  userAdminUrl: '',
  fetchSettings: [],
  catalogsForUpdate: [],
  news: [],
  newsOrder,
  newsPage: 0,
  newsPageCount: 0,
  newsTotalCount: 0,
  systemInoperabilityList: [],
  systemInoperabilityListOrder: 'startDate,desc',
  systemInoperabilityListPage: 0,
  systemInoperabilityListPageCount: 0,
  systemInoperabilityListTotalCount: 0,
  systemInoperabilityListShowSave: false,
  systemInoperabilityListDisableSave: false,
  systemInoperabilityListAddRecord: null,
  systemInoperabilityFormRef: null,
  systemInoperabilityFormUnsavedRecords: [],
  systemInoperabilityFormElementRef: null,
  controlOfNewslettersListPage: 0,
  controlOfNewslettersListTotalCount: 0,
  controlOfNewslettersList: [],
  mangeTestUsersList: [],
  mangeTestUsersListOrder: 'fullName,asc',
  mangeTestUsersListPage: 0,
  mangeTestUsersListPageCount: 0,
  mangeTestUsersListTotalCount: 0,
  immediateTestPurchase: 0,
};

export function adminReducer(state = initial, action: AdminAction) {
  switch (action.type) {
    case AdminActionsEnum.ADMIN_SET_USER_ADMIN_URL: {
      const newState: IAdminState = {
        ...state,
        userAdminUrl: action.payload.userAdminUrl,
      };

      return newState;
    }
    case AdminActionsEnum.ADMIN_SET_FETCH_SETTINGS: {
      const newState: IAdminState = {
        ...state,
        fetchSettings: action.payload.settings,
      };

      return newState;
    }
    case AdminActionsEnum.ADMIN_SET_CATALOGS_FOR_UPDATE: {
      const newState: IAdminState = {
        ...state,
        catalogsForUpdate: action.payload.catalogs,
      };

      return newState;
    }
    case AdminActionsEnum.ADMIN_SET_CATALOG_NAME: {
      const newState: IAdminState = {
        ...state,
        catalogName: action.payload.catalogName,
      };

      return newState;
    }
    case AdminActionsEnum.ADMIN_SET_NEWS_ORDER: {
      const newState: IAdminState = {
        ...state,
        newsOrder: action.payload.order,
      };

      return newState;
    }
    case AdminActionsEnum.ADMIN_SET_NEWS: {
      const { news, newsPage, newsPageCount, newsTotalCount } = action.payload;
      const newState: IAdminState = {
        ...state,
        news,
        newsPage,
        newsPageCount,
        newsTotalCount,
      };

      return newState;
    }
    case AdminActionsEnum.ADMIN_SET_SISTEM_INOPERABILITY_LIST: {
      const {
        systemInoperabilityList,
        systemInoperabilityListPage,
        systemInoperabilityListPageCount,
        systemInoperabilityListTotalCount,
      } = action.payload;
      const newState: IAdminState = {
        ...state,
        systemInoperabilityList,
        systemInoperabilityListPage,
        systemInoperabilityListPageCount,
        systemInoperabilityListTotalCount,
      };

      return newState;
    }
    case AdminActionsEnum.ADMIN_SET_SMEV_RESEND_BY_SENDING_DATE: {
      const {
        controlOfNewslettersList,
        controlOfNewslettersListPage,
        controlOfNewslettersListTotalCount,
      } = action.payload;
      const newState: IAdminState = {
        ...state,
        controlOfNewslettersList,
        controlOfNewslettersListPage,
        controlOfNewslettersListTotalCount,
      };

      return newState;
    }

    case AdminActionsEnum.ADMIN_SET_SISTEM_INOPERABILITY_LIST_ORDER: {
      const newState: IAdminState = {
        ...state,
        systemInoperabilityListOrder: action.payload.order,
      };

      return newState;
    }

    case AdminActionsEnum.ADMIN_SET_SISTEM_INOPERABILITY_LIST_SHOW_SAVE: {
      const { systemInoperabilityListShowSave: isShowSave } = action.payload;
      const newState: IAdminState = {
        ...state,
        systemInoperabilityListShowSave: isShowSave,
      };

      return newState;
    }

    case AdminActionsEnum.ADMIN_SET_SISTEM_INOPERABILITY_LIST_DISABLE_SAVE: {
      const { systemInoperabilityListDisableSave: isShowSave } = action.payload;
      const newState: IAdminState = {
        ...state,
        systemInoperabilityListDisableSave: isShowSave,
      };

      return newState;
    }

    case AdminActionsEnum.ADMIN_SET_SISTEM_INOPERABILITY_SET_FORM_REF: {
      return {
        ...state,
        systemInoperabilityFormRef: action.payload.systemInoperabilityFormRef,
      };
    }

    case AdminActionsEnum.ADMIN_SET_SISTEM_INOPERABILITY_FORM_UNSAVED_RECORDS: {
      const newState: IAdminState = {
        ...state,
        systemInoperabilityFormUnsavedRecords: action.payload.unsavedRecords,
      };

      return newState;
    }

    case AdminActionsEnum.ADMIN_SET_SISTEM_INOPERABILITY_SET_FORM_ELEMENT_REF: {
      const newState: IAdminState = {
        ...state,
        systemInoperabilityFormElementRef: action.payload.systemInoperabilityFormElementRef,
      };

      return newState;
    }

    case AdminActionsEnum.ADMIN_SET_MANAGE_TEST_USERS_LIST: {
      const {
        mangeTestUsersList,
        mangeTestUsersListPage,
        mangeTestUsersListPageCount,
        mangeTestUsersListTotalCount,
      } = action.payload;
      const newState: IAdminState = {
        ...state,
        mangeTestUsersList,
        mangeTestUsersListPage,
        mangeTestUsersListPageCount,
        mangeTestUsersListTotalCount,
      };

      return newState;
    }

    case AdminActionsEnum.ADMIN_SET_MANAGE_TEST_USERS_LIST_ORDER: {
      const newState: IAdminState = {
        ...state,
        mangeTestUsersListOrder: action.payload.order,
      };

      return newState;
    }

    default:
      return state;
  }
}
